import { AuthenticationService } from '@cbuild/core';

export abstract class PermissionComponent {
  constructor(protected authenticationService: AuthenticationService) {}

  public hasModulePermission(name: string): boolean {
    return this.authenticationService.hasModulePermission(name);
  }

  public hasFeaturePermission(name: string): boolean {
    return this.authenticationService.hasFeaturePermission(name);
  }

  public hasUserPermission(
    appCode: string,
    requiredPermissionMask: number
  ): boolean {
    return this.authenticationService.hasUserPermission(
      appCode,
      requiredPermissionMask
    );
  }
}
